<template>
  <div class="user-help" v-wechat-title="$route.meta.title = title()">
      <van-tabs v-model="activeName" color="#006EFF" swipeable  @change="onTabChange">
          <van-tab :title="$t('append_field.network_import')" name="a" v-if="shouldShowTab('a')">
              <div ref="pageContainerA" class="page-container">
                  <div class="section">
                    <h1>{{ $t('append_field.network_connection') }}</h1>
                    <p>{{ $t('append_field.network_methods') }}</p>
                    <p>{{ $t('append_field.network_method_1') }}</p>
                    <div v-if="lang == 'zh'">
                      <div v-for="(image, index) in images_1" :key="index">
                      <img :src="image.src" :alt="image.alt" @click="openPreview(images_1, index)" />
                      </div>
                    </div>
                    <div v-else>
                      <div v-for="(image, index) in images_en_1" :key="index">
                      <img :src="image.src" :alt="image.alt" @click="openPreview(images_en_1, index)" />
                      </div>
                    </div>
                  </div>
                  <div class="section" v-if="lang == 'zh'">
                    <p>{{ $t('append_field.network_method_2') }}</p>
                      <div v-for="(image, index) in images_2" :key="index">
                      <img :src="image.src" :alt="image.alt" @click="openPreview(images_2, index)" />
                      </div>
                  </div>
                  <div class="section">
                    <h2>{{ $t('append_field.account_registration') }}</h2>
                    <p>{{ $t('append_field.registration_methods') }}</p>
                    <p>{{ $t('append_field.registration_method_1') }}</p>
                    <div v-if="lang == 'zh'">
                        <div v-for="(image, index) in images_3" :key="index">
                      <img :src="image.src" :alt="image.alt" @click="openPreview(images_3, index)" />
                        </div>
                    </div>
                   <div v-else>
                      <div v-for="(image, index) in images_en_3" :key="index">
                      <img :src="image.src" :alt="image.alt" @click="openPreview(images_en_3, index)" />
                      </div>
                    </div>
                  </div>
                  <div class="section">
                    <p>{{ $t('append_field.registration_method_2') }}</p>
                    <p>{{ $t('append_field.invitation_code_source') }}</p>
                    <div v-if="lang == 'zh'">
                       <div v-for="(image, index) in images_4" :key="index">
                      <img :src="image.src" :alt="image.alt" @click="openPreview(images_4, index)" />
                      </div>
                    </div>
                    <div v-else>
                      <div v-for="(image, index) in images_en_4" :key="index">
                      <img :src="image.src" :alt="image.alt" @click="openPreview(images_en_4, index)" />
                      </div>
                    </div>
                  </div>
                  <div class="section">
                    <h2>{{ $t('append_field.device_connection') }}</h2>
                    <p>{{ $t('append_field.device_connection_steps') }}</p>
                     <div v-if="lang == 'zh'">
                       <div v-for="(image, index) in images_5" :key="index" class="section-img">
                      <img :src="image.src" :alt="image.alt" @click="openPreview(images_5, index)" />
                      </div>
                    </div>
                    <div v-else>
                      <div v-for="(image, index) in images_en_5" :key="index" class="section-img">
                      <img :src="image.src" :alt="image.alt" @click="openPreview(images_en_5, index)" />
                      </div>
                    </div>
                  </div>
              </div>
          </van-tab >
          <van-tab :title="$t('append_field.mobile_mode')" name="b" v-if="shouldShowTab('b')">
              <div ref="pageContainerB" class="page-container">
              <div class="section">
                <h1>{{ $t('append_field.connect_terminal') }}<span style="color: #ff0000">{{ $t('append_field.mobile_mode_tip') }}</span></h1>
                <p>{{ $t('append_field.scan_qr_wifi') }}</p>
                <p>{{ $t('append_field.scan_qr_code') }}</p>
                <div v-if="lang == 'zh'">
                  <div v-for="(image, index) in images_7" :key="index" class="section-img">
                    <img v-if="index < 2" :src="image.src" :alt="image.alt" @click="openPreview(images_7, index)" />
                  </div>
                </div>
                <div v-else>
                  <div v-for="(image, index) in images_en_7" :key="index" class="section-img">
                    <img v-if="index < 2" :src="image.src" :alt="image.alt" @click="openPreview(images_en_7, index)" />
                  </div>
                </div>
                <p>{{ $t('append_field.device_List') }}</p>
                <div v-if="lang == 'zh'">
                  <div v-for="(image, index) in images_7" :key="index" class="section-img">
                    <img v-if="index === 2" :src="image.src" :alt="image.alt" @click="openPreview(images_7, index)" />
                  </div>
                </div>
                <div v-else>
                  <div v-for="(image, index) in images_en_7" :key="index" class="section-img">
                    <img v-if="index === 2" :src="image.src" :alt="image.alt" @click="openPreview(images_en_7, index)" />
                  </div>
                </div>
              </div>
              <div class="section">
                <h1>{{ $t('append_field.remote_Command') }}</h1>
                <p>{{ $t('append_field.send_Command') }}</p>
                <div v-if="lang == 'zh'">
                  <div v-for="(image, index) in images_7" :key="index" class="section-img">
                    <img v-if="index > 2 && index < 5" :src="image.src" :alt="image.alt" @click="openPreview(images_7, index)" />
                  </div>
                </div>
                <div v-else>
                  <div v-for="(image, index) in images_en_7" :key="index" class="section-img">
                    <img v-if="index > 2 && index < 5" :src="image.src" :alt="image.alt" @click="openPreview(images_en_7, index)" />
                  </div>
                </div>
              </div>
              <div class="section">
                <h1>{{ $t('append_field.quick_send_program') }}</h1>
                <p>{{ $t('append_field.quick_send_steps') }}</p>
                <div v-if="lang == 'zh'">
                  <div v-for="(image, index) in images_7" :key="index" class="section-img">
                    <img v-if="index === 5" :src="image.src" :alt="image.alt" @click="openPreview(images_7, index)" />
                  </div>
                </div>
                <div v-else>
                  <div v-for="(image, index) in images_en_7" :key="index" class="section-img">
                    <img v-if="index === 5" :src="image.src" :alt="image.alt" @click="openPreview(images_en_7, index)" />
                  </div>
                </div>
              </div>
              <div class="section">
                <h1>{{ $t('append_field.program_creation') }}</h1>
                <p>{{ $t('append_field.new_program') }}</p>
                <div v-if="lang == 'zh'">
                  <div v-for="(image, index) in images_7" :key="index" class="section-img">
                    <img v-if="index === 6" :src="image.src" :alt="image.alt" @click="openPreview(images_7, index)" />
                  </div>
                </div>
                <div v-else>
                  <div v-for="(image, index) in images_en_7" :key="index" class="section-img">
                    <img v-if="index === 6" :src="image.src" :alt="image.alt" @click="openPreview(images_en_7, index)" />
                  </div>
                </div>
                <p v-html="$t('append_field.program_editing')" class="section-program-editing"></p>
                <div v-if="lang == 'zh'">
                  <div v-for="(image, index) in images_7" :key="index" class="section-img">
                    <img v-if="index > 6 && index < 9" :src="image.src" :alt="image.alt" @click="openPreview(images_7, index)" />
                  </div>
                </div>
                <div v-else>
                  <div v-for="(image, index) in images_en_7" :key="index" class="section-img">
                    <img v-if="index > 6 && index < 9" :src="image.src" :alt="image.alt" @click="openPreview(images_en_7, index)" />
                  </div>
                </div>
              </div>
              <div class="section">
                <h1>{{ $t('append_field.program_sending') }}</h1>
                <p>{{ $t('append_field.send_program_steps') }}</p>
                <div v-if="lang == 'zh'">
                  <div v-for="(image, index) in images_7" :key="index" class="section-img">
                    <img v-if="index === 9" :src="image.src" :alt="image.alt" @click="openPreview(images_7, index)" />
                  </div>
                </div>
                <div v-else>
                  <div v-for="(image, index) in images_en_7" :key="index" class="section-img">
                    <img v-if="index === 9" :src="image.src" :alt="image.alt" @click="openPreview(images_en_7, index)" />
                  </div>
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab  :title="$t('append_field.standalone_mode')" name="c"  v-if="shouldShowTab('c')">
              <div ref="pageContainerC" class="page-container">
                <div class="section">
                  <h1>{{ $t('append_field.simple_mode_title') }}</h1>
                  <p>{{ $t('append_field.simple_mode_description') }}</p>
                  <p>{{ $t('append_field.simple_mode_note') }}</p>
                  <div v-if="lang == 'zh'">
                    <div v-for="(image, index) in images_6" :key="index">
                      <img v-if="index === 0" :src="image.src" :alt="image.alt" @click="openPreview(images_6, index)" />
                    </div>
                  </div>
                  <div v-else>
                    <div v-for="(image, index) in images_en_6" :key="index">
                      <img v-if="index === 0" :src="image.src" :alt="image.alt" @click="openPreview(images_en_6, index)" />
                    </div>
                  </div>
                </div>
                <div class="section">
                    <h2>{{ $t('append_field.regular_mode_title') }}</h2>
                    <p v-html="$t('append_field.regular_mode_description')"></p>
                    <p v-html="$t('append_field.regular_mode_steps')"></p>
                    <div v-if="lang == 'zh'">
                      <div v-for="(image, index) in images_6" :key="index">
                        <img v-if="index === 1" :src="image.src" :alt="image.alt" @click="openPreview(images_6, index)" />
                      </div>
                    </div>
                    <div v-else>
                      <div v-for="(image, index) in images_en_6" :key="index">
                        <img v-if="index === 1" :src="image.src" :alt="image.alt" @click="openPreview(images_en_6, index)" />
                      </div>
                    </div>
                  </div>
                <div class="section">
                    <p>{{ $t('append_field.step_one') }}<br>{{ $t('append_field.step_one_description') }}</p>
                    <p>{{ $t('append_field.step_two') }}<br>{{ $t('append_field.step_two_description') }}</p>
                    <div v-if="lang == 'zh'">
                      <div v-for="(image, index) in images_6" :key="index">
                        <img v-if="index === 2" :src="image.src" :alt="image.alt" @click="openPreview(images_6, index)" />
                      </div>
                    </div>
                    <div v-else>
                      <div v-for="(image, index) in images_en_6" :key="index">
                        <img v-if="index === 2" :src="image.src" :alt="image.alt" @click="openPreview(images_en_6, index)" />
                      </div>
                    </div>
                  </div>
                <div class="section">
                    <p>{{ $t('append_field.step_three') }}<br>{{ $t('append_field.step_three_description') }}</p>
                    <div v-if="lang == 'zh'">
                      <div v-for="(image, index) in images_6" :key="index">
                        <img v-if="index === 3" :src="image.src" :alt="image.alt" @click="openPreview(images_6, index)" />
                      </div>
                    </div>
                    <div v-else>
                      <div v-for="(image, index) in images_en_6" :key="index">
                        <img v-if="index === 3" :src="image.src" :alt="image.alt" @click="openPreview(images_en_6, index)" />
                      </div>
                    </div>
                  </div>
                <div class="section">
                    <p>{{ $t('append_field.step_four') }}<br>{{ $t('append_field.step_four_description') }}</p>
                    <p>{{ $t('append_field.step_five') }}<br>{{ $t('append_field.step_five_description') }}</p>
                    <h2>{{ $t('append_field.play_order_title') }}</h2>
                    <p v-html="$t('append_field.play_order_description')"></p>
                    <p>{{ $t('append_field.document_playback_note') }}</p>
                    <div v-if="lang == 'zh'">
                      <div v-for="(image, index) in images_6" :key="index" >
                        <img v-if="index === 4" :src="image.src" :alt="image.alt" @click="openPreview(images_6, index)" />
                      </div>
                    </div>
                    <div v-else>
                      <div v-for="(image, index) in images_en_6" :key="index">
                        <img v-if="index === 4" :src="image.src" :alt="image.alt" @click="openPreview(images_en_6, index)" />
                      </div>
                    </div>
                  </div>
           </div>
          </van-tab>
      </van-tabs>
    <vue-easy-lightbox
                      :visible="previewVisible"
                      :imgs="previewImages"
                      :index="previewIndex"
                      @hide="closePreview"
                    />
  </div>
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox'

export default {
  name: 'StaticPage',
  components: {
    VueEasyLightbox
  },
  data() {
    return {
      images_1: [
          { src: '/static/images/help/zh/network/image_4.png', alt: '' },
          { src: '/static/images/help/zh/network/image_5.png', alt: '' },
          { src: '/static/images/help/zh/network/image_6.png', alt: '' },
          { src: '/static/images/help/zh/network/image_7.png', alt: '' },
          { src: '/static/images/help/zh/network/image_8.png', alt: '' },
          { src: '/static/images/help/zh/network/image_9.png', alt: '' }
        ],
      images_2: [
          { src: '/static/images/help/zh/network/image_10.png', alt: '图片 9' },
          { src: '/static/images/help/zh/network/image_11.png', alt: '图片 10' },
          { src: '/static/images/help/zh/network/image_12.png', alt: '图片 11' },
          { src: '/static/images/help/zh/network/image_13.png', alt: '图片 12' },
          { src: '/static/images/help/zh/network/image_14.png', alt: '图片 13' }
        ],
      images_3: [
          { src: '/static/images/help/zh/network/image_15.png', alt: '图片 15' },
          { src: '/static/images/help/zh/network/image_16.png', alt: '图片 16' },
          { src: '/static/images/help/zh/network/image_17.png', alt: '图片 17' },
          { src: '/static/images/help/zh/network/image_18.png', alt: '图片 18' },
          { src: '/static/images/help/zh/network/image_19.png', alt: '图片 19' },
          { src: '/static/images/help/zh/network/image_20.png', alt: '图片 20' }
        ],
      images_4: [
          { src: '/static/images/help/zh/network/image_21.png', alt: '图片 22' },
          { src: '/static/images/help/zh/network/image_22.png', alt: '图片 23' },
          { src: '/static/images/help/zh/network/image_23.png', alt: '图片 24' }
        ],
      images_5: [
          { src: '/static/images/help/zh/network/image_24.png', alt: '图片 26' },
          { src: '/static/images/help/zh/network/image_25.png', alt: '图片 27' },
          { src: '/static/images/help/zh/network/image_26.png', alt: '图片 28' },
          { src: '/static/images/help/zh/network/image_27.png', alt: '图片 29' },
          { src: '/static/images/help/zh/network/image_28.png', alt: '图片 30' },
          { src: '/static/images/help/zh/network/image_29.png', alt: '图片 31' }
        ],
      images_6: [
          { src: '/static/images/help/zh/standalone/image_1.png', alt: '图片 26' },
          { src: '/static/images/help/zh/standalone/image_2.png', alt: '图片 27' },
          { src: '/static/images/help/zh/standalone/image_3.png', alt: '图片 28' },
          { src: '/static/images/help/zh/standalone/image_4.png', alt: '图片 29' },
          { src: '/static/images/help/zh/standalone/image_5.png', alt: '图片 30' },
        ],
      images_en_1: [
        { src: '/static/images/help/en/network/image_4_en.png', alt: '图片 2' },
        { src: '/static/images/help/en/network/image_5_en.png', alt: '图片 3' },
        { src: '/static/images/help/en/network/image_6_en.png', alt: '图片 4' },
        { src: '/static/images/help/en/network/image_7_en.png', alt: '图片 5' }
      ],
      images_en_3: [
        { src: '/static/images/help/en/network/image_8_en.png', alt: '图片 6' },
        { src: '/static/images/help/en/network/image_9_en.png', alt: '图片 7' },
        { src: '/static/images/help/en/network/image_10_en.png', alt: '图片 8' },
        { src: '/static/images/help/en/network/image_11_en.png', alt: '图片 9' }
      ],
      images_en_4: [
        { src: '/static/images/help/en/network/image_12_en.png', alt: '图片 10' },
        { src: '/static/images/help/en/network/image_13_en.png', alt: '图片 11' },
        { src: '/static/images/help/en/network/image_14_en.png', alt: '图片 12' },
        { src: '/static/images/help/en/network/image_15_en.png', alt: '图片 13' },
        { src: '/static/images/help/en/network/image_16_en.png', alt: '图片 14' }
      ],
      images_en_5: [
        { src: '/static/images/help/en/network/image_17_en.png', alt: '图片 15' },
        { src: '/static/images/help/en/network/image_18_en.png', alt: '图片 16' },
        { src: '/static/images/help/en/network/image_19_en.png', alt: '图片 17' },
        { src: '/static/images/help/en/network/image_20_en.png', alt: '图片 18' },
        { src: '/static/images/help/en/network/image_21_en.png', alt: '图片 19' },
        { src: '/static/images/help/en/network/image_22_en.png', alt: '图片 20' }
      ],
      images_en_6: [
        { src: '/static/images/help/en/standalone/image_en_1.png', alt: '' },
        { src: '/static/images/help/en/standalone/image_en_2.png', alt: '' },
        { src: '/static/images/help/en/standalone/image_en_3.png', alt: '' },
        { src: '/static/images/help/en/standalone/image_en_4.png', alt: '' },
        { src: '/static/images/help/en/standalone/image_en_5.png', alt: '' },
      ],
      previewVisible: false,
      previewImages: [],
      previewIndex: 0,
      lang:'',
      activeName:'a',
      imageCount: 12,
      typeParam: null // 控制显示的 type 参数

    }
  },
  computed: {
    images_7() {
      return this.generateImageList('zh')
    },
    images_en_7() {
      return this.generateImageList('en')
    },
  },
  mounted() {
    this.lang=this.$route.query.lang?this.$route.query.lang:'zh'
    this.$i18n.locale = this.lang
    this.checkUrlParams()
  },
  methods: {
    generateImageList(lang) {
      const images = []
      if(lang==='en'){
         for (let i = 1; i <= this.imageCount; i++) {
            images.push({
              src: `/static/images/help/${lang}/phone/image_en_${i}.png`, // 根据实际路径调整
              alt: `Image ${i}`,
            })
          }
          return images
      }else {
         for (let i = 1; i <= this.imageCount; i++) {
            images.push({
              src: `/static/images/help/${lang}/phone/image_${i}.png`, // 根据实际路径调整
              alt: `Image ${i}`,
            })
          }
          return images
      }
     },
    title() {
        switch (this.activeName) {
          case 'a':
            return this.$t('append_field.network_import')
          case 'b':
            return this.$t('append_field.mobile_mode')
           case 'c':
             return this.$t('append_field.standalone_mode')
        }
      },
    openPreview(images, index) {
        this.previewImages = images.map(image => image.src)
        this.previewIndex = index
        this.previewVisible = true

      },
    closePreview() {
        this.previewVisible = false
      },
    checkUrlParams() {
      this.typeParam =  this.$route.query.type?this.$route.query.type:''
      if (this.typeParam === 'mobile') {
        this.activeName = 'b' // 当 type=mobile 时，默认激活 tab b
      }
    },
    shouldShowTab(tabName) {
      if (this.typeParam === 'mobile') {
        return tabName === 'b' // 仅显示 tab b
      }
      return true // 显示所有标签页
    },
    /*
    * 切换tab时滚动到顶部
    * */
    onTabChange(name) {

      this.$nextTick(() => {
        let pageContainer
        if (name === 'b') {
          pageContainer = this.$refs.pageContainerB
        } else if (name === 'c') {
          pageContainer = this.$refs.pageContainerC
        }else {
          pageContainer = this.$refs.pageContainerA
        }
        if (pageContainer) {
           pageContainer.scrollTop = 0
        }
      })
    }
  },

}
</script>

<style>
  .user-help{
    height: 100vh; /* 使容器高度为视口高度 */
    .van-tab__text--ellipsis{
      overflow: hidden !important;
    }
  }

  .page-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    background-color: #fff;
    border: 1px solid #ccc;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    height: calc(100vh - 86px); /* 计算内容区高度 */
    overflow-y: auto; /* 内容区可滚动 */

  }

  .section {
    margin-bottom: 40px;
  }
    h1{
      font-size: 18px;
      margin: 10px 0;
    }
    h2 , p{
      margin: 5px 0;
    }
  div  .section-program-editing{
    img{
      display: inline-block;
      vertical-align: middle; /* 使图片和文本垂直对齐 */
      width: 20px; /* 根据需要调整图片的宽度 */
      height: 20px; /* 根据需要调整图片的高度 */
      margin: 0 5px; /* 根据需要调整图片和文本之间的间距 */
    }
  }
  .section-img{
    display: flex;
    justify-content: space-around;
  }
  .section img {
    max-width: 100%;
    max-height: 300px;

    display: block;
    margin-top: 20px;
    cursor: pointer; /* 添加鼠标指针样式 */
  }
</style>
